import React, { useEffect, useState } from "react";
import { useAuth } from "../Context/store/context";
import config from "../../config";
import { _post } from "../../apiClient";
import { _showToast } from "../../toastHelper";

export default function ChangePassword({ onClose }) {
  const { logoutuser, showLoader, hideLoader, getToken } = useAuth();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});


  useEffect(() => {
    if (!getToken())
      logoutuser();
    else {
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    }
  }, []);



  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      changePassword();
    }
  };

  const validate = () => {
    const errors = {};

    if (!currentPassword || (currentPassword && currentPassword.trim() == "")) {
      errors.currentPassword = "Current password is required";
    }

    if (!newPassword || (newPassword && newPassword.trim() == "")) {
      errors.newPassword = "New password is required";
    }

    if (!confirmPassword || (confirmPassword && confirmPassword.trim() == "")) {
      errors.confirmPassword = "Confirm password is required";
    }


    if (newPassword && newPassword != "" && confirmPassword && confirmPassword != "" && confirmPassword != newPassword) {
      errors.confirmPassword = "Password not matching";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;

  }

  const changePassword = async () => {
    showLoader();
    await _post("/change-password", {
      "oldPassword": currentPassword,
      "password": newPassword
    })
      .then(() => {
        _showToast("Password updated successfully.", "success");
        onClose();
        hideLoader();
      })
      .catch((error) => {
        _showToast(error, "error");
        hideLoader();
      });
  };
  return (
    <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Change Password</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3 row align-items-center">
                <label className="form-label col-4 required">
                  Current Password
                </label>
                <div className="col-8">
                  <input
                    type="password"
                    className={`form-control ${errors.currentPassword ? "is-invalid" : ""}`}
                    name="currentPassword"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                  />
                  {errors.currentPassword && (
                    <div className="text-danger">
                      {errors.currentPassword}
                    </div>
                  )}
                </div>
              </div>

              <div className="mb-3 row align-items-center">
                <label className="form-label col-4 required">
                  New Password
                </label>
                <div className="col-8">
                  <input
                    type="password"
                    className={`form-control ${errors.newPassword ? "is-invalid" : ""}`}
                    name="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  {errors.newPassword && (
                    <div className="text-danger ">
                      {errors.newPassword}
                    </div>
                  )}
                </div>
              </div>

              <div className="mb-3 row align-items-center">
                <label className="form-label col-4 required">
                  Confirm Password
                </label>
                <div className="col-8">
                  <input
                    type="password"
                    className={`form-control ${errors.confirmPassword ? "is-invalid" : ""}`}
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  {errors.confirmPassword && (
                    <div className="text-danger">
                      {errors.confirmPassword}
                    </div>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-between">
                <div className="text-start">
                  <button type="button" className="btn btn-secondary" onClick={onClose}>
                    Close
                  </button>
                </div>
                <div className="text-end">
                  <button type="submit" className="btn btn-primary"  >
                    Change Password
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
